import { axiosInstance } from './apiCommon';
import { PagedResult } from 'types/search-common/PagedResult';
import {
  DashboardListItemModel,
  DashboardQuickStatsModel,
  DashboardQuickStatsRequest,
  DashboardSearchRequest,
} from 'types/dashboard/DashboardListItemModel';

export const searchDashboard = async (request: DashboardSearchRequest): Promise<PagedResult<DashboardListItemModel>> =>
  (await axiosInstance.post<PagedResult<DashboardListItemModel>>('/api/v2/Dashboard/search', request)).data;

export const getDashboardQuickStats = async (request: DashboardQuickStatsRequest): Promise<DashboardQuickStatsModel> =>
  (await axiosInstance.get<DashboardQuickStatsModel>('/api/v2/Dashboard/quick-stats', { params: request })).data;
